import { DateInput } from 'components/inputs/DateInput';
import { IFormInputSpecDatePlusPeriod } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a date plus period input.
 */
export default function DatePlusPeriodInputPreview({ spec }: { spec: IFormInputSpecDatePlusPeriod }) {
  return <DateInput required={spec.required} readOnly size="sm" />;
}
